import axios from "axios";
import AuthService from "./auth.service";
import qs from "qs";

//esto se debe cambiar antes de actualizar el build y subir a produccion.
//const API_URL = "https://cmx.unilimpio.com/index.php/api/";
//const API_URL = "http://cmxbk/index.php/api/";

const API_URL = process.env.REACT_APP_API_URL;




const getPuntos = (evalId,user) => {

  //const user = AuthService.getCurrentUser();

  return axios
  .get(API_URL + "getPuntos/" + evalId, 
    { headers: {"Authorization" : `Bearer ${user.token}`}})
  .catch(function (error) {
    if(error.message.includes('401')){
        localStorage.removeItem('user');
       }

  })
};

const getEvalState = (evalId,user) => {

//const user = AuthService.getCurrentUser();

  
      return axios
      .get(API_URL + "getEvalState/" + evalId, 
        { headers: {"Authorization" : `Bearer ${user.token}`}})
      .catch(function (error) {
        if(error.message.includes('401')){
        localStorage.removeItem('user');
        localStorage.removeItem("cmx_flashMessage");
        localStorage.removeItem("cmx_compliance_ubId_selected");
        return error;
       }

      })
  
  
};

const getTask = (taskId,user) => {
  //const user = AuthService.getCurrentUser();

  return axios
  .get(API_URL + "getTask/" + taskId, 
    { headers: {"Authorization" : `Bearer ${user.token}`}})
  .catch(function (error) {
    if(error.message.includes('401')){
        localStorage.removeItem('user');
       }

  })
};

const getServicePub = (serviceId) => {

  return axios
  .get(API_URL + "getServicePublic/" + serviceId, 
    { headers: {}})
  .catch(function (error) {
    

  })
};

const getService = (servId,user) => {
  //const user = AuthService.getCurrentUser();

  return axios
  .get(API_URL + "getService/" + servId, 
    { headers: {"Authorization" : `Bearer ${user.token}`}})
  .catch(function (error) {
    if(error.message.includes('401')){
        localStorage.removeItem('user');
        localStorage.removeItem("cmx_flashMessage");
        localStorage.removeItem("cmx_compliance_ubId_selected");
       }
       return error
  })
};

const getIp = () => {
  return axios
  .get('https://geolocation-db.com/json/e6256a50-6cef-11ef-9699-010d5e77689d', 
    { headers: {}})
  .catch(function (error) {
    console.log("unable to connect to User info API:"+error);

  })
};

const getEvals = () => {
  const user = AuthService.getCurrentUser();

  
  return axios
  .get(API_URL + "getEvals/" + user.uId, { headers: {"Authorization" : `Bearer ${user.token}`} } )
  .catch(function (error){
    console.log('catched an error !! - ',error)
    //read the response and look for familiar messages or satus codes, example 401 means unauthorized, most likely token is expiredshould redirect to the login screen
    if (error.message.includes('401')){
      localStorage.removeItem("user");
      localStorage.removeItem("cmx_flashMessage");
        localStorage.removeItem("cmx_compliance_ubId_selected");
         
    }
    return error;

  });
  
};

const getUbCmx = (ubId,user) => {
 // const user = AuthService.getCurrentUser();

  return axios
  .get(API_URL + "getUbCmx/" + ubId, { headers: {"Authorization" : `Bearer ${user.token}`} } )
  .catch(function (error){
    console.log('catched an error !! - ',error)
    //read the response and look for familiar messages or satus codes, example 401 means unauthorized, most likely token is expiredshould redirect to the login screen
    if (error.message.includes('401')){
      localStorage.removeItem("user");
      localStorage.removeItem("cmx_flashMessage");
        localStorage.removeItem("cmx_compliance_ubId_selected");
          
    }
    
    return error

  });
  
};

const getTasks = (user) => {
  //const user = AuthService.getCurrentUser();

  const options = {uId: user.uId, orderBy: 'due_date',sort: 'DESC', limit:99999}

  return axios
  .get(API_URL + "getTasks/" + options.uId + '/' + options.orderBy+ '/' + options.sort + '/' + options.limit, { headers: {"Authorization" : `Bearer ${user.token}`} } )
  .catch(function (error){
    
    if(error.message.includes('401')){
        localStorage.removeItem('user');
        localStorage.removeItem("cmx_flashMessage");
        localStorage.removeItem("cmx_compliance_ubId_selected");
       
      }

      return error
  });
  
};

const getCourses = (uId,oId,catId,user) => {
  //const user = AuthService.getCurrentUser();

  const options = {uId: uId, oId: oId, catId: catId}

  return axios
  .get(API_URL + "getCursos/" + options.uId + '/' + options.oId+ '/' + options.catId + '', { headers: {"Authorization" : `Bearer ${user.token}`} } )
  .catch(function (error){
    
    if(error.message.includes('401')){
        localStorage.removeItem('user');
        localStorage.removeItem("cmx_flashMessage");
        localStorage.removeItem("cmx_compliance_ubId_selected");
       
      }

      return error
  });
  
};

const setCursoStart = (user,courseId) => {
  
  //const user = AuthService.getCurrentUser();

  const options = {uId: user.uId, courseId: courseId,}

  return axios
  .get(API_URL + "setUserCursoStart/" + options.uId + '/' + options.courseId, { headers: {"Authorization" : `Bearer ${user.token}`} } )
  .catch(function (error){
    
    if(error.message.includes('401')){
        localStorage.removeItem('user');
        localStorage.removeItem("cmx_flashMessage");
       
       
      }

      return error
  });
  
};

const setCursoComplete = (user,courseId, data) => {
 // const user = AuthService.getCurrentUser();

  const options = {uId: user.uId, courseId: courseId,}

  return axios
  .post(API_URL + "setUserCursoComplete/" + options.uId + '/' + options.courseId, data,
    { headers: {"Authorization" : `Bearer ${user.token}`} } )
  .catch(function (error){
    
    if(error.message.includes('401')){
        localStorage.removeItem('user');
        localStorage.removeItem("cmx_flashMessage");
        localStorage.removeItem("cmx_compliance_ubId_selected");
       
      }

      return error
  });
  
};

const getServices = (ubId,user) => {
  //const user = AuthService.getCurrentUser();

  return axios
  .get(API_URL + "getServices/" + ubId, { headers: {"Authorization" : `Bearer ${user.token}`} } )
  .catch(function (error){
    if(error.message.includes('401')){
        localStorage.removeItem('user');
        localStorage.removeItem("cmx_flashMessage");
        localStorage.removeItem("cmx_compliance_ubId_selected");
       }
       return error
  });
  
};

const getUbs = (user) => {

  
  //const user = AuthService.getCurrentUser();

 
    return axios
      .get(API_URL + "getUbs/" + user.uId, { headers: {"Authorization" : `Bearer ${user.token}`} } )
      .catch(function (error){
      if(error.message.includes('401')){

        localStorage.removeItem("user");
        localStorage.removeItem("cmx_flashMessage");
        localStorage.removeItem("cmx_compliance_ubId_selected");
        //console.log()
      }
      return error
    });
 
  
  
};

const setPunto = (evalId, instance, user, data) => {
  
  //const user = AuthService.getCurrentUser();


  return axios
    .post(API_URL + "setPunto/" + user.uId + "/" + evalId + '/' + instance, data,
      { headers: {
        "Authorization" : `Bearer ${user.token}`
      } }
      

    )
    .then((response) => {
     
      console.log(response)

      return response;
    })
    .catch( (error) => {
      
      console.log(error)
      console.log(error.message)
      console.log(error.statusCode)
       if(error.message.includes('401')){
        localStorage.removeItem('user');
        localStorage.removeItem("cmx_flashMessage");
        localStorage.removeItem("cmx_compliance_ubId_selected");
       }

      return error;
    
    })
};

const setEval = (ubId, verifId, user) => {
  
  //const user = AuthService.getCurrentUser();


  return axios
    .get(API_URL + "setEval/" + user.uId + "/" + ubId + "/" + verifId,  
      { headers: {
        "Authorization" : `Bearer ${user.token}`
      } }
      

    )
    .then((response) => {
     
      console.log(response)
      return response;
    })
    .catch( (error) => {
      
      console.log(error)
      if(error.message.includes('401')){
        localStorage.removeItem('user');
        localStorage.removeItem("cmx_flashMessage");
        localStorage.removeItem("cmx_compliance_ubId_selected");
       }

      return error;
    
    })
};

const setUx = (serviceId, user, data) => {
  
  //const user = AuthService.getCurrentUser();


  return axios
    .post(API_URL + "setUx/" + serviceId , qs.stringify(data),
      { headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        "Authorization" : `Bearer ${user.token}`
        
      } }
      

    )
    .then((response) => {
      /*
      if (response.data.flag) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }
      */

      return response;
    })
    .catch( (error) => {
      
      if(error.message.includes('401')){
        localStorage.removeItem('user');
        localStorage.removeItem("cmx_flashMessage");
        localStorage.removeItem("cmx_compliance_ubId_selected");
       }

      return error;
    
    })
};

const setTask = (serviceId, uxId, user, data) => {
  
  //const user = AuthService.getCurrentUser();


  return axios
    .post(API_URL + "setTask/" + user.uId + "/"+serviceId + "/" + uxId, data,
      { headers: {
        //'Content-Type': 'application/x-www-form-urlencoded',
        "Authorization" : `Bearer ${user.token}`
        
      } }
      

    )
    .then((response) => {
      /*
      if (response.data.flag) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }
      */

      return response;
    })
    .catch( (error) => {
      
      if(error.message.includes('401')){
        localStorage.removeItem('user');
        localStorage.removeItem("cmx_flashMessage");
        localStorage.removeItem("cmx_compliance_ubId_selected");
       }
      return error;
    
    })
};

const updateTask = (taskId, user, data) => {
  
  //const user = AuthService.getCurrentUser();


  return axios
    .post(API_URL + "updateTask/" + user.uId + "/"+taskId, data,
      { headers: {
        //'Content-Type': 'application/x-www-form-urlencoded',
         //'Content-Type': 'multipart/form-data',
        "Authorization" : `Bearer ${user.token}`
        
      } }
      

    )
    .then((response) => {
      /*
      if (response.data.flag) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }
      */

      return response;
    })
    .catch( (error) => {
      if(error.message.includes('401')){
        localStorage.removeItem('user');
        localStorage.removeItem("cmx_flashMessage");
        localStorage.removeItem("cmx_compliance_ubId_selected");
       }

      return error;
    
    })
};

const setUxPub = (serviceId, data) => {
  
  

  return axios
    .post(API_URL + "setUxPublic/" + serviceId , data,
      { headers: {
        //'Content-Type': 'application/x-www-form-urlencoded',
        
        
      } }
      

    )
    .then((response) => {
      /*
      if (response.data.flag) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }
      */

      return response;
    })
    .catch( (error) => {
      

      return error;
    
    })
};

const setUxComm = (uxId, data) => {
  
  

  return axios
    .post(API_URL + "setUxComm/" + uxId , data,
      { headers: {
        //'Content-Type': 'application/x-www-form-urlencoded',
        
        
      } }
      

    )
    .then((response) => {
      /*
      if (response.data.flag) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }
      */

      return response;
    })
    .catch( (error) => {
      

      return error;
    
    })
};

const setBadUx = (serviceId, uxId, user,data) => {
  
  //const user = AuthService.getCurrentUser();


  return axios
    .post(API_URL + "setBadUx/" + serviceId + "/" + uxId, qs.stringify(data),
      { headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        "Authorization" : `Bearer ${user.token}`
        
      } }
      

    )
    .then((response) => {
      /*
      if (response.data.flag) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }
      */

      return response;
    })
    .catch( (error) => {
      

      return error;
    
    })
};

const getWeatherInfo = (location) => {
  
  return axios
  .get('https://api.weatherapi.com/v1/forecast.json?q=' + location + '&days=3&lang=es&key=65a40346f3f74a788b8181738252509', 
    { headers: {}})
  .catch(function (error) {
    

  })
  

  
  
};

const updateFlash = ({flashMessage}) => {
  
  const previousFlash =  localStorage.getItem('cmx_flashMessage');
  
  if( previousFlash){
      localStorage.removeItem('cmx_flashMessage');
  }
  
  localStorage.setItem('cmx_flashMessage',flashMessage);

  return null;

  
  
};




const UserService = {
  getPuntos,
  getEvals,
  getTasks,
  getCourses,
  getEvalState,
  getTask,
  setPunto,
  setEval,
  setUx,
  setTask,
  setCursoStart,
  setCursoComplete,
  updateTask,
  setUxPub,
  setUxComm,
  setBadUx,
  getUbs,
  getUbCmx,
  getServices,
  getService,
  getServicePub,
  getIp,
  getWeatherInfo,
  
  //getUserBoard,
  //getModeratorBoard,
  //getAdminBoard,
  updateFlash
}

export default UserService;
